import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import styled, {css} from 'styled-components'

export const StyledMenuItem = styled(MenuItem)(
    ({theme: {palette}}) => css`
        align-items: center;
        & svg {
            width: 16px;
            height: 16px;
            fill: ${palette.neutral[500]};
        }
    `
)
